import { Component } from "react";
import { connect } from "react-redux";

import { Card, Tooltip, Button, Table, Input, Modal } from "antd";
import { req_list_rts_course } from "../../api";
import { usrRole } from "../../utils/dataUtil";
import {
  getNowAcademicYear,
  getNowAcademicSemester,
  convertMinutesToHoursAndMinutes,
} from "../../utils/dateUtil";
import RemoteLearningStudentModal from "./remote-learning-student-modal";

class RemoteLearningCourse extends Component {
  state = {
    loading: false,
    deviceWidth: 0,
    userLevel: "NORMAL",
    item: {},
    // 分頁參數
    data: [],
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    academicYear: getNowAcademicYear(new Date()),
    academicSemester: getNowAcademicSemester(new Date()),
    domnloadFile: "",
    isShowModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_list_items();
  }

  componentWillUnmount() {
    //window.removeEventListener("resize", this.resize.bind(this))
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_items = async () => {
    const { academicYear, academicSemester } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, loading: true, data: [] });
    const result = await req_list_rts_course(
      userLevel,
      userCode,
      academicYear,
      academicSemester,
      token,
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items, loading: false });
      // console.log(items);
    } else {
      const items = [];
      this.setState({
        data: items,
        loading: false,
      });
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "學年度",
        dataIndex: "AcademicYear",
        key: "AcademicYear",
        align: "center",
        width: 50,
        responsive: ["md"],
        render: (text) => <>{text}</>,
      },
      {
        title: "學期",
        dataIndex: "AcademicSemeter",
        key: "AcademicSemeter",
        align: "center",
        width: 40,
        responsive: ["md"],
        render: (text) => <>{text}</>,
      },
      {
        title: "開課序號",
        dataIndex: "OpenCourseSerialKey",
        key: "OpenCourseSerialKey",
        align: "center",
        width: 50,
        responsive: ["md"],
        render: (text) => <>{text}</>,
      },
      {
        title: "課程名稱",
        dataIndex: "CourseName",
        key: "CourseName",
        width: 120,
        render: (text) => <>{text}</>,
      },
      {
        title: "學分",
        dataIndex: "AcademicCredit",
        key: "AcademicCredit",
        align: "center",
        responsive: ["md"],
        width: 40,
        render: (text) => <>{text}</>,
      },
      {
        title: "開課班級",
        dataIndex: "ClassroomName",
        key: "ClassroomName",
        align: "center",
        responsive: ["md"],
        width: 60,
        render: (text) => <>{text}</>,
      },
      {
        title: "任課老師",
        dataIndex: "TeacherName",
        key: "TeacherName",
        align: "center",
        width: 50,
        render: (text) => <>{text}</>,
      },
      {
        title: "修讀人數",
        dataIndex: "AllSudentTotal",
        key: "AllSudentTotal",
        align: "center",
        responsive: ["md"],
        width: 50,
        render: (text) => <>{text}</>,
      },
      {
        title: "全班累計閱讀",
        width: 120,
        render: (item) => (
          <div style={{ textAlign: "center" }}>
            <button
              className={
                item.ClassInfoStatus === "PASS"
                  ? "btn btn-success btn-sm"
                  : "btn btn-danger btn-sm"
              }
              style={{ width: "150px" }}
              onClick={() => this.handle_btn_event("list_students", item)}
            >
              {item.ClassInfoStatus === "PASS" ? "已達標" : "未達標"} <hr />
              合計 {convertMinutesToHoursAndMinutes(item.AllStayMinuteTotal)}
            </button>
          </div>
        ),
      },
      {
        title: "全班累計討論",
        width: 120,
        render: (item) => (
          <div style={{ textAlign: "center" }}>
            <button
              className={
                item.ClassInfoStatus === "PASS"
                  ? "btn btn-success btn-sm"
                  : "btn btn-danger btn-sm"
              }
              style={{ width: "110px" }}
              // onClick={() => this.handle_btn_event("list_students", item)}
            >
              {item.AllFrequencyCountTotal === "PASS" ? "已達標" : "未達標"}{" "}
              <hr />
              合計 {item.AllFrequencyCountTotal} 次數
            </button>
          </div>
        ),
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_list_items();
      },
    );
  };

  handle_data_refresh = () => {
    this.api_list_items();
  };

  handle_btn_event = (modal, item) => {
    switch (modal) {
      case "list_students":
        this.setState({ item, isShowModal: true });
        break;
      case "download":
        break;
      default:
    }
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { item, data, loading, academicYear, academicSemester, isShowModal } =
      this.state;
    const title = (
      <>
        <Input
          placeholder="學年度"
          style={{ width: 50, margin: "0 5px" }}
          value={academicYear}
          onChange={(event) =>
            this.setState({ academicYear: event.target.value })
          }
        />
        <Input
          placeholder="學期"
          style={{ width: 34, margin: "0 5px" }}
          value={academicSemester}
          onChange={(event) =>
            this.setState({ academicSemester: event.target.value })
          }
        />
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
      </>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          rowKey="Uid"
          columns={this.columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
        <Modal
          destroyOnClose={true}
          visible={isShowModal}
          width={600}
          onOk={() => {
            this.setState({ isShowModal: false });
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <RemoteLearningStudentModal data={item} />
        </Modal>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {},
)(RemoteLearningCourse);
